<template>
  <b-container>
    <b-form-group label="DisplayName" label-for="DisplayName">
      <b-form-input
        type="text"
        id="DisplayName"
        placeholder="Informe o nome de exibição"
        v-model="model.displayName"
      />
      <span class="text-danger" v-if="modelstate['DisplayName']">
        {{ modelstate["DisplayName"][0] }}
      </span>
    </b-form-group>

    <b-form-group label="Name" label-for="Name">
      <b-form-input
        type="text"
        id="Name"
        placeholder="Informe o nome de exibição"
        v-model="model.name"
      />
      <span class="text-danger" v-if="modelstate['Name']">{{
        modelstate["Name"][0]
      }}</span>
    </b-form-group>

    <!-- {{ model }} -->
  </b-container>
</template>

<script>
// import AwesomeMask from "awesome-mask";

export default {
  name: "SystemIntegrationCrudData",
  props: {
    model: Object,
    modelstate: Object,
  },
  //   watch: {
  //     model() {
  //       this.loadTableRows();
  //     }
  //   },
  //   directives: {
  //     mask: AwesomeMask,
  //   },
};
</script>
